const validatePromoCode = async (code: string): Promise<boolean> => {
  const formData = new URLSearchParams();
  formData.append("code", code);
  try {
    const response = await fetch(
      "/ajax/ambassadeur/parrainage/promo-code-validity",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData.toString(),
      }
    );
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error("Erreur lors de la requête:", error);
    return false;
  }
};

export default validatePromoCode;